import { question } from "@msys/question-isomorphic";
import { ModalContent, ModalDialog, ModalTitle } from "@msys/ui";
import { WizardSection } from "../WizardSection.js";

export function QuoteCreateWizardModal({
  organisationId,
  templateId,
  onClose,
  onComplete,
}: {
  organisationId: string;
  templateId: string;
  onClose: () => void;
  onComplete: (
    result: Array<question.AnsweredQuestion>
  ) => Promise<void> | void;
}) {
  return (
    <ModalDialog handleClose={onClose} maxWidth="lg">
      <ModalTitle />
      <ModalContent>
        <WizardSection
          onComplete={onComplete}
          onClose={onClose}
          wizardConfiguration={{
            navigationType: null,
            questionStrategy: {
              type: "questionControl",
              askWhen: "onQuoteCreate",
              askWhom: "contractor",
              startingNode: { type: "root" },
            },
            requestInitialAnswers: "false",
            sourceDoc: {
              type: "template",
              templateId,
              contractorId: organisationId,
            },
            showCloseButton: "true",
            showSkipWizardButton: "true",
          }}
          initialAnswers={[]}
        />
      </ModalContent>
    </ModalDialog>
  );
}
